import { Loader2 } from "lucide-react";
import useFlowStripe from "@/hooks/stripe/useFlowStripe";
import { t } from "i18next";
import { useEffect } from "react";
import { toast } from "@/hooks/use-toast";
import { Button } from "@/components/ui/button";

export default function SetupSubscription(): JSX.Element {
  const { data, loading, error } = useFlowStripe();

  useEffect(() => {
    if (error) {
      toast({
        variant: "destructive",
        title: error,
      });
    }
  }, [error]);

  if (loading) {
    return (
      <div className="flex justify-center">
        <Loader2 className="animate-spin" />
      </div>
    );
  }

  if (error) {
    return <>{error && <p>{error}</p>}</>;
  }

  return (
    <div>
      {data && (
        <div className="space-y-6">
          <div>
            <p>
              {t("settings.subscription.setupSubscriptions.clickOnTheButton")}
            </p>
            <p>
              {t(
                "settings.subscription.setupSubscriptions.oncePaymentIsSuccessful"
              )}
            </p>
          </div>
          <Button
            onClick={() => window.open(data, "_blank", "noopener,noreferrer")}
          >
            {t("settings.subscription.setupSubscriptions.manageButton")}
          </Button>
        </div>
      )}
    </div>
  );
}
